import { InternshipModel } from "common/models/page-models/internship/internship/internship-data-model";
import { FormWidgetService } from "../form-widget.service";
import { SystemService } from "common/services/core-services/system.service";
import { Router } from "@angular/router";
import { InternshipMetaModel } from "common/models/page-models/internship/internship/internship-meta-model";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { Injectable } from "@angular/core";
import { InternshipFormDataService } from "common/services/data-services/admin/internship/intership-form.service";
import { environment } from "src/environments/environment";
import { API_URL } from "common/constants/sm-constants";
import { SmMetaModel } from "common/models/utility-models/meta-model";
import { BatchListDataService } from "common/services/data-services/custom-service/batch-service";
import { branchListDataService } from "common/services/data-services/custom-service/branchList-service";
import { stateListDataService } from "common/services/data-services/custom-service/stateList-service.service";
import { zoneListDataService } from "common/services/data-services/custom-service/zoneList-service";
import { InternshipDeleteDataService } from "common/services/data-services/admin/internship/internship-delete-data.service";
import { error } from "jquery";
import { InternshipSendInviteDataService } from "common/services/data-services/admin/internship/internship-sendInvite-data.service";
import { InternshipReSendInviteDataService } from "common/services/data-services/admin/internship/internship-reInvite-data.service";
import { InternshipBatchwiseDataService } from "common/services/data-services/admin/internship/internship-batchwise-data.service";

@Injectable({
    providedIn: 'root'
})
export class InternshipWidgetService extends FormWidgetService<InternshipModel> {

    constructor(
        protected ds: InternshipFormDataService,
        protected ss: SystemService,
        protected router: Router,
        // private batchList: BatchListDataService,
        private branchList: branchListDataService,
        private stateList: stateListDataService,
        private regionList: zoneListDataService,
        private deleteInternship: InternshipDeleteDataService,
        private sendInviteToStudents: InternshipSendInviteDataService,
        private sendReInviteToStudents: InternshipReSendInviteDataService,
        private internshipStudentbatchwise: InternshipBatchwiseDataService

    ) {
        super(ds);
    }
    internshipStats = null
    //------------Student Chart Data-----------------
    invitationChartData = null
    availabilityChartData = null
    assignedStatusChartData = null
    completionStatusChartData = null
    //------------Internship Chart Data----------------- //
    internassignedChartData = null
    joinedChartData = null
    interncontinueChartData = null
    interncompletionStatusChartData = null;
    currentYear: string = new Date().getFullYear().toString();
    status: any = '2'

    getMetaModel(): MetaModel | InternshipMetaModel {
        const meta = new InternshipMetaModel();
        return meta.getMetaModel();
    }

    override getUrlList(): any[] {
        const postObj = {
            typeOfStatus: Number(this.status),
            year: this.currentYear,
        }
        const urlList = [
            { url: environment.apiUrl + API_URL.internshipList, payload: postObj },
            { url: environment.apiUrl + API_URL.studentListData, payload: postObj },
            { url: environment.apiUrl + API_URL.studentListChartData, payload: postObj },
            // { url: environment.apiUrl + API_URL.InternshipstudentListBatchwise, payload: postObj },
        ];

        return urlList;
    }

    override prepareMetaModel(dataModel: InternshipModel, metaModel: any, routeData: WidgetModel): Promise<InternshipMetaModel> {
        return new Promise<InternshipMetaModel>((resolve, reject) => {

            const propertiesToFetch = [
                { key: 'selectedBatch', service: this.internshipStudentbatchwise },
                { key: 'selectedBranch', service: this.branchList },
                { key: 'selectedRegion', service: this.regionList },
                { key: 'selectedState', service: this.stateList },
            ];

            Promise.all(
                propertiesToFetch.map(item =>
                    item.service.postData(item.key === 'selectedBatch' ? {year: this.currentYear}:{}).then(data => {
                        // console.log(data.details, 'detailss')
                        metaModel.properties[item.key] = data.details;
                    })
                )
            ).catch(error => {
                // console.log("An error occurred:", error);
            });


            // console.log("DATAMODEL", dataModel);

            metaModel.properties.filteredStudents = [...dataModel.studentsList]
            metaModel.properties.filteredInternships = [...dataModel.internshipList]
            metaModel.properties.internshipStats = dataModel.internshipStats.totalInternships
            metaModel.properties.internshipStats = dataModel.internshipStats.assignedStudents
            metaModel.properties.internshipStats = dataModel.internshipStats.joinedStudents
            metaModel.properties.internshipStats = dataModel.internshipStats.notJoined
            metaModel.properties.internshipStats = dataModel.internshipStats.completed
            metaModel.properties.internshipStats = dataModel.internshipStats.discontinued

            this.internshipStats = dataModel.internshipStats.totalInternships
            this.internshipStats = dataModel.internshipStats.assignedStudents
            this.internshipStats = dataModel.internshipStats.joinedStudents
            this.internshipStats = dataModel.internshipStats.notJoined
            this.internshipStats = dataModel.internshipStats.completed
            this.internshipStats = dataModel.internshipStats.discontinued

            this.invitationChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Invitation Status',
                    colorByPoint: true,
                    data: [
                        { name: 'Invited', y: +dataModel.invitationCounts.invited, color: '#37897c' },
                        { name: 'Not Invited', y: +dataModel.invitationCounts.notInvited, color: '#2db9a3' }
                    ]
                }]
            };
            this.availabilityChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Availability',
                    colorByPoint: true,
                    data: [
                        { name: 'Available', y: +dataModel.availabilityCounts.available, color: '#FFE279' },
                        { name: 'Not Available', y: +dataModel.availabilityCounts.notAvailable, color: '#FF6969' },
                        { name: 'Not Responded', y: +dataModel.availabilityCounts.notResponded, color: '#D8D8D8' }
                    ]
                }]
            };
            this.assignedStatusChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Assigned Status',
                    colorByPoint: true,
                    data: [
                        { name: 'Assigned', y: +dataModel.assignedCounts.assigned, color: '#8dd283' },
                        { name: 'Not Assigned', y: +dataModel.assignedCounts.notAssigned, color: '#73a696' }
                    ]
                }]
            };
            this.completionStatusChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Completion Status',
                    colorByPoint: true,
                    data: [
                        { name: 'Completed', y: +dataModel.completionCounts.completed, color: '#5bafd8' },
                        { name: 'Discontinued', y: +dataModel.completionCounts.discontinued, color: '#0d6385' },
                        { name: 'Not Joined', y: +dataModel.completionCounts.notJoined, color: '#b9c2c4' }
                    ]
                }]
            };

            //------------Internship Chart Data-----------------
            this.internassignedChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Assignes Students',
                    colorByPoint: true,
                    data: [
                        { name: 'Joined', y: +dataModel.internassignedCounts.joined, color: '#c98331' },
                        { name: 'Not Joined', y: +dataModel.internassignedCounts.notJoined, color: '#e8d992' }
                    ]
                }]
            };

            //  Joined Status Chart Configuration
            this.joinedChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Joined Students',
                    colorByPoint: true,
                    data: [
                        { name: 'Continued', y: +dataModel.joinedCounts.continued, color: '#ff834a' },
                        { name: 'Discontinued', y: +dataModel.joinedCounts.disContinued, color: '#ffd851' }
                    ]
                }]
            };

            //  Continue Status Chart Configuration
            this.interncontinueChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Continue Status',
                    colorByPoint: true,
                    data: [
                        { name: 'Completed', y: +dataModel.interncontinueCounts.completed, color: '#528db7' },
                        { name: 'Discontinued', y: +dataModel.interncontinueCounts.disContinued, color: '#79bce2' },
                        { name: 'Not Joined', y: +dataModel.interncontinueCounts.notJoined, color: '#b1b1b1' }
                    ]
                }]
            };

            // Completion Status Chart Configuration
            this.interncompletionStatusChartData = {
                chart: {
                    type: 'pie',
                    backgroundColor: null
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        slicedOffset: 0,
                        cursor: 'pointer',
                        borderWidth: 1,
                        borderColor: '#ffffff',
                        innerSize: '80%',
                        dataLabels: {
                            enabled: false,
                            format: '<b>{point.name}</b>: {point.y}',
                            distance: -30
                        },
                        showInLegend: false,
                        states: {
                            hover: {
                                enabled: false // Disable hover highlight
                            },
                            select: {
                                enabled: false // Disable selection highlight
                            }
                        }
                    }
                },
                series: [{
                    enableMouseTracking: false,
                    name: 'Completion Status',
                    colorByPoint: true,
                    data: [
                        { name: 'Completed', y: +dataModel.interncompletionCounts.completed, color: '#83bd75' },
                        { name: 'Not Completed', y: +dataModel.interncompletionCounts.notCompleted, color: '#549274' }
                    ]
                }]
            };
            resolve(metaModel);
        });
    }

    deleteInternshipData(id: any[]): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.deleteInternship.postData({ id: id }).then(() => {
                resolve('data deleted successfully')
            })
                .catch((error) => {
                })
        })
    }

    sendInvite(internshipMasterIds: any[]): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.sendInviteToStudents.postData({ internshipMasterIds: internshipMasterIds }).then(() => {
                resolve('Invite sent successfully')
            })
                .catch((error) => {
                })
        })
    }

    reInvite(internshipMasterIds: any[]): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.sendReInviteToStudents.postData({ internshipMasterIds: internshipMasterIds }).then(() => {
                resolve('Invite sent successfully')
            })
                .catch((error) => {
                })
        })
    }

    getInternshipData(data: any = {
        typeOfStatus: this.status,
        year: this.currentYear
    }): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ds.postData(data).then((response: any) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    }

    getRefreshDataByYear(value: string, widget: any, type: 'year' | 'status'): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            type === 'year' ? this.currentYear = value : this.status = Number(value)
            this.getDataFromMultipleAPI().then((data) => {
                const models = {
                    dataModel: data
                };
                this.prepareMetaModel(data, this.getMetaModel(), widget).then((metaModel) => {
                    models['metaModel'] = metaModel;
                    resolve(models);
                });
            });
        })
    }
}
